import { findActiveCue } from './chunk-NOPW2CG3.js';
import { $ariaBool } from './chunk-EVP5E6AO.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { $$_create_walker, $$_effect, $$_attr, $$_listen, $$_ref, $$_create_template } from 'maverick.js/dom';
import { signal, effect, peek } from 'maverick.js';
import { defineElement, Component } from 'maverick.js/element';

var $$_templ = /* @__PURE__ */ $$_create_template(`<!$><img part="img" loading="eager" decoding="async" aria-hidden="true" />`);
var Thumbnail = class extends Component {
  constructor(instance) {
    super(instance);
    this.ma = null;
    this.ub = null;
    this.uc = [];
    this.da = signal("");
    this.vc = signal(false);
    this.wc = signal(null);
    this.K = -1;
    this.a = useMedia();
  }
  onAttach() {
    this.setAttributes({
      "data-loading": this.xc.bind(this),
      "aria-hidden": $ariaBool(this.v.bind(this))
    });
  }
  onConnect() {
    effect(this.ha.bind(this));
    effect(this.vg.bind(this));
    effect(this.wg.bind(this));
  }
  ha() {
    this.da();
    this.a.$store.thumbnails();
    this.vc.set(false);
  }
  Sb() {
    this.vc.set(true);
    this.Nd();
  }
  xc() {
    return !this.v() && !this.vc();
  }
  v() {
    const { duration, thumbnailCues } = this.a.$store;
    return !Number.isFinite(duration()) || thumbnailCues().length === 0;
  }
  vg() {
    const { time } = this.$props, { duration, thumbnailCues } = this.a.$store, _cues = thumbnailCues(), _time = time();
    if (!_cues || !Number.isFinite(duration())) {
      this.wc.set(null);
      return;
    }
    this.wc.set(findActiveCue(_time, _cues));
  }
  xg(el) {
    this.ma = el;
  }
  wg() {
    const activeCue = this.wc(), thumbnails = peek(this.a.$store.thumbnails);
    if (!thumbnails || !activeCue) {
      this.da.set("");
      this.Od();
      return;
    }
    const [_src, _coords = ""] = (activeCue.text || "").split("#");
    this.ub = this.yg(_coords);
    if (!this.ub) {
      this.Od();
      return;
    }
    this.da.set(this.zg(thumbnails, _src));
    this.Nd();
  }
  zg(baseURL, src) {
    return !/https?:/.test(src) ? `${baseURL.split("/").slice(0, -1).join("/")}${src.replace(/^\/?/, "/")}`.replace(
      /^\/\//,
      "/"
    ) : src;
  }
  yg(coords) {
    const [props, values] = coords.split("="), resolvedCoords = {}, coordValues = values.split(",");
    if (!props || !values)
      return null;
    for (let i = 0; i < props.length; i++)
      resolvedCoords[props[i]] = +coordValues[i];
    return resolvedCoords;
  }
  Nd() {
    if (this.K > 0)
      return;
    this.K = requestAnimationFrame(() => {
      this.Ag();
      this.K = -1;
    });
  }
  Ag() {
    if (!this.ma || !this.ub)
      return;
    const { w, h, x, y } = this.ub, { maxWidth, maxHeight, minWidth, minHeight } = getComputedStyle(this.el), minRatio = Math.max(parseInt(minWidth) / w, parseInt(minHeight) / h), maxRatio = Math.min(parseInt(maxWidth) / w, parseInt(maxHeight) / h), scale = maxRatio < 1 ? maxRatio : minRatio > 1 ? minRatio : 1;
    this.Za(this.el, "--thumbnail-width", `${w * scale}px`);
    this.Za(this.el, "--thumbnail-height", `${h * scale}px`);
    this.Za(this.ma, "width", `${this.ma.naturalWidth * scale}px`);
    this.Za(this.ma, "height", `${this.ma.naturalHeight * scale}px`);
    this.Za(this.ma, "transform", `translate(-${x * scale}px, -${y * scale}px)`);
  }
  Za(el, name, value) {
    el.style.setProperty(name, value);
    this.uc.push(() => el.style.removeProperty(name));
  }
  Od() {
    for (const reset of this.uc)
      reset();
    this.uc = [];
  }
  render() {
    const { crossorigin } = this.a.$store;
    return (() => {
      const [$$_root, $$_walker] = $$_create_walker($$_templ);
      $$_effect(() => $$_attr($$_root, "src", this.da()));
      $$_effect(() => $$_attr($$_root, "crossorigin", crossorigin()));
      $$_listen($$_root, "load", this.Sb.bind(this));
      $$_ref($$_root, this.xg.bind(this));
      return $$_root;
    })();
  }
};
Thumbnail.el = defineElement({
  tagName: "media-thumbnail",
  props: { time: 0 }
});

export { Thumbnail };
